import ClubRegistrationLayout from "./ClubRegistrationLayout";

export default ClubRegistrationLayout